import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import { useCallback } from 'react';
import { setIsTextInputFocused } from '../store/slices/textSearchSlice';
import { setTextSearch } from '../store/slices/textSearchSlice';

export function useTextSearch() {
  const dispatch = useDispatch<AppDispatch>();
  const channel = useSelector((state: RootState) => state.textSearch);

  return {
    textSearch: channel.textSearch,
    isTextInputFocused: channel.isTextInputFocused,
    setTextSearch: useCallback((textSearch: string) => 
        dispatch(setTextSearch(textSearch)), [dispatch]),
    setIsTextInputFocused: useCallback((isTextInputFocused: boolean) => 
        dispatch(setIsTextInputFocused(isTextInputFocused)), [dispatch]),
  };
}